import { CmsSection } from './CmsSection.tsx';
import { CmsNewsSection } from './CmsNewsSection.tsx';
import { CmsNewsletterSection } from './CmsNewsletterSection.tsx';
import { CmsSponsorsSection } from './CmsSponsorsSection.tsx';
import { CmsPeopleSection } from './CmsPeopleSection.tsx';
import { CmsTicketHighlightSection } from './CmsTicketHighlightSection.tsx';
import { CmsTimetableSection } from './CmsTimetableSection.tsx';
import { CmsArtistsSection } from './CmsArtistsSection.tsx';
import { CmsFaqSection } from './CmsFaqSection.tsx';
import { CmsPinnedNewsSection } from './CmsPinnedNewsSection.tsx';
import { CmsHeroLineup } from './CmsHeroLineup.tsx';
import { CmsPlaylistSection } from './CmsPlaylistSection.tsx';
import { CmsMapSection } from './CmsMapSection.tsx';
import { CmsProgramSection } from './CmsProgramSection.tsx';
import { CmsAppSection } from './CmsAppSection.tsx';
import { CmsTicketsSection } from './CmsTicketsSection.tsx';
import { CmsScheduleSection } from './CmsScheduleSection.tsx';
import { CmsGallerySection } from './CmsGallerySection.tsx';
import { CmsPhotoWallSection } from './CmsPhotoWallSection.tsx';
import type { ComponentType } from 'react';
import type { PageSection, PageSectionType } from '../../lib/types.ts';

/** One renderer per section type. Adding a new section type means adding a
 *  single entry here (plus its component) instead of growing a switch. */
const SECTION_RENDERERS: { [K in PageSectionType]: ComponentType<Extract<PageSection, { type: K }>> } = {
  content: CmsSection,
  news: CmsNewsSection,
  newsletter: CmsNewsletterSection,
  sponsors: CmsSponsorsSection,
  people: CmsPeopleSection,
  ticketHighlight: CmsTicketHighlightSection,
  timetable: CmsTimetableSection,
  artists: CmsArtistsSection,
  faq: CmsFaqSection,
  pinnedNews: CmsPinnedNewsSection,
  heroLineup: CmsHeroLineup,
  playlist: CmsPlaylistSection,
  map: CmsMapSection,
  program: CmsProgramSection,
  app: CmsAppSection,
  tickets: CmsTicketsSection,
  schedule: CmsScheduleSection,
  gallery: CmsGallerySection,
  photoWall: CmsPhotoWallSection,
};

/** Renders the correct section component for a page section by its type.
 *  Unknown/future types are ignored (CMS-060) rather than falling through to
 *  a mismatched renderer. */
export function CmsSectionRenderer({ section }: { section: PageSection }) {
  const Renderer = SECTION_RENDERERS[section.type] as ComponentType<PageSection> | undefined;
  if (!Renderer) return null;
  return <Renderer {...section} />;
}
